import type { RouteObject } from "react-router-dom";
import { useParams, useSearchParams } from "react-router-dom";
import { StoreDetailPage } from "@/modules/stores/pages/StoreDetailPage";
import { StoreOrderPage } from "@/modules/stores/pages/StoreOrderPage";
import { StoresPage } from "@/modules/stores/pages/StoresPage";
import { useLocale } from "@admin/app/locale";
import type { StoreKind } from "@/lib/api/types";

function toNumber(value: string | null, fallback: number) {
  const parsed = value ? Number(value) : Number.NaN;
  return Number.isFinite(parsed) ? parsed : fallback;
}

function AdminStoreListRoute({ storeKind }: { storeKind: StoreKind }) {
  const locale = useLocale();
  const [searchParams] = useSearchParams();

  return (
    <StoresPage
      locale={locale}
      limit={toNumber(searchParams.get("limit"), 20)}
      offset={toNumber(searchParams.get("offset"), 0)}
      sellerId={searchParams.get("sellerId")?.trim() || undefined}
      storeKind={storeKind}
    />
  );
}

/** The list with the record's drawer open over it. */
function AdminStoreDetailRoute({ storeKind }: { storeKind?: StoreKind }) {
  const locale = useLocale();
  const { id = "" } = useParams();

  return <StoreDetailPage locale={locale} storeId={id} storeKind={storeKind} />;
}

function AdminStoreOrderRoute() {
  const locale = useLocale();
  const { id = "", orderId = "" } = useParams();
  return <StoreOrderPage locale={locale} storeId={id} orderId={orderId} />;
}

export const storeRoutes: RouteObject[] = [
  {
    path: "restaurants",
    element: <AdminStoreListRoute storeKind="RESTAURANT" />,
  },
  {
    path: "restaurants/:id",
    element: <AdminStoreDetailRoute storeKind="RESTAURANT" />,
  },
  {
    path: "stores",
    element: <AdminStoreListRoute storeKind="DEFAULT" />,
  },
  {
    path: "stores/:id",
    element: <AdminStoreDetailRoute />,
  },
  {
    path: "stores/:id/orders/:orderId",
    element: <AdminStoreOrderRoute />,
  },
];
